export const dataLibW = [{
  word: 'wat',
  partOfSpeech: 'N',
  definition: 'rat',
  egSentenceKw: 'Wat épi Souwi té vlé kwennen Chat.',
  egSentenceEn: 'Rat and Mouse wanted to fool Cat.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. rat]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wouj',
  partOfSpeech: 'ADJ',
  definition: 'red',
  egSentenceKw: 'Nonm-lan ka pòté on chimiz wouj',
  egSentenceEn: 'The man\'s wearing a red shirt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. rouge]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wòb',
  partOfSpeech: 'N',
  definition: ['dress'],
  egSentenceKw: 'Ou mété wòb ou lanvè.',
  egSentenceEn: 'You put your dress on backwards.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. robe]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wété',
  partOfSpeech: 'V',
  definition: [null],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['wèsté'],
}, {
  word: 'wèsté',
  partOfSpeech: 'V',
  definition: ['to remain', 'to stay'],
  egSentenceKw: 'Wèsté la jis tan mwen vini.',
  egSentenceEn: 'Stay there until I come.',
  synonym: ['wézidan'],
  antonym: [null],
  etymology: '[< Fr. rester]',
  dialect: '🇱🇨',
  variant: ['wété'],
}, {
  word: 'wèsté',
  partOfSpeech: 'V',
  definition: ['to live', 'to reside'],
  egSentenceKw: 'Yo ka wèsté Kastwi.',
  egSentenceEn: 'They live in Castries',
  synonym: ['wézidan'],
  antonym: [null],
  etymology: '[< Fr. rester]',
  dialect: '🇱🇨',
  variant: ['wété'],
}, {
  word: 'waflé',
  partOfSpeech: 'V',
  definition: ['to raffle'],
  egSentenceKw: 'Nou ka waflé on bèf òswè-a.',
  egSentenceEn: 'We are raffling a cow tonight.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. rafler]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'waya',
  partOfSpeech: 'N',
  definition: ['wire'],
  egSentenceKw: 'Yo fè pak-la épi waya.',
  egSentenceEn: 'They made the fence with wire.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. wire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'widjèkté',
  partOfSpeech: 'V',
  definition: ['to reject'],
  egSentenceKw: 'Fanmi\'y menm widjèkté\'y',
  egSentenceEn: 'His own family rejected him.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. rejeter]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wivòlva',
  partOfSpeech: 'N',
  definition: ['revolver', 'pistol'],
  egSentenceKw: 'I ni wivòlva\'y a koté\'y.',
  egSentenceEn: 'He has his revolver on his side.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. revolver]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wòf',
  partOfSpeech: 'N',
  definition: ['wharf'],
  egSentenceKw: 'Yo najé jik tan yo wivé asou wòf-la.',
  egSentenceEn: 'They swam until the got to the wharf.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. wharf]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wanmyé',
  partOfSpeech: 'N',
  definition: ['wood pigeon'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. ramier]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wondèl',
  partOfSpeech: 'N',
  definition: ['a type of bird'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. rondelle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wivé',
  partOfSpeech: 'N',
  definition: ['to arrive', 'to reach'],
  egSentenceKw: 'Batiman-an sipozé wivé òswè-a.',
  egSentenceEn: 'The boat is supposed to arrive tonight.',
  synonym: [null],
  antonym: ['kité', 'pati'],
  etymology: '[< Fr. arriver]',
  dialect: '🇱🇨',
  variant: ['ivé', 'ouvé'],
}, {
  word: 'wivé',
  partOfSpeech: 'N',
  definition: ['to happen (to)'],
  egSentenceKw: 'Ki sa ki wivé\'w?',
  egSentenceEn: 'What happened to you?',
  synonym: [null],
  antonym: ['kité', 'pati'],
  etymology: '[< Fr. arriver]',
  dialect: '🇱🇨',
  variant: ['ivé', 'ouvé'],
}, {
  word: 'wè',
  partOfSpeech: 'V',
  definition: ['to see'],
  egSentenceKw: 'Nou maché anba-a la mé nou pa wè léfan-an.',
  egSentenceEn: 'We walked down there but we didn\'t see the elephant.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. voir]',
  dialect: '🇱🇨',
  variant: [null],
},
];
